import type { IcIcon } from "./types";

export const IcAlert: IcIcon = (properties) => (
  <svg
    fill="currentColor"
    viewBox="0 0 48 48"
    xmlns="http://www.w3.org/2000/svg"
    {...properties}
  >
    <path d="M24 37.75c-7.042 0-12.75-5.708-12.75-12.75S16.958 12.25 24 12.25 36.75 17.958 36.75 25 31.042 37.75 24 37.75zm0-1.5c6.213 0 11.25-5.037 11.25-11.25S30.213 13.75 24 13.75 12.75 18.787 12.75 25 17.787 36.25 24 36.25z" />
    <path d="M23.25 19a.75.75 0 1 1 1.5 0v6.984a.75.75 0 1 1-1.5 0V19zm.774 12.383a1.38 1.38 0 0 1-.984-2.4 1.44 1.44 0 0 1 1.956 0 1.356 1.356 0 0 1 0 1.956c-.25.276-.601.437-.972.444z" />
  </svg>
);
